import React, { useCallback, useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Input from "rc-input";
import classNames from "classnames";
import Select, { Option } from "rc-select";
import ReactLoading from "react-loading";
import Axios from "axios";

export const MarketplaceType = (props) => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const {
    setList,
    currentType,
    setCurrentType,
    setCurrentTotal,
    categories,
    typeLoading,
    setSearchLock,
  } = props;
  const [query, setQuery] = useState();
  const isWindow = () => typeof window !== "undefined";
  const isDocument = () => typeof document !== "undefined";
  const [fixedSider, setfixedSider] = useState(false);

  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const scrollTop = document.documentElement.scrollTop;

      const listBoxTop = document.querySelector(".application-box").offsetTop;

      const listBoxbottom =
        document.querySelector(".application-box").offsetHeight + listBoxTop;
      if (scrollTop >= listBoxTop - 100 && scrollTop < listBoxbottom - 540) {
        setfixedSider(true);
      } else {
        setfixedSider(false);
      }
    }
  }, []);

  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchApp = () => {
    setSearchLock(true);
    Axios.get(`/api/marketplace-list?page=1&category=&query=${query}`)
      .then((res) => {
        const dataList = res?.data?.data || [];
        setList(dataList);
      })
      .catch((res) => {
        console.log("error" + res);
      });
  };

  const onChange = (e) => {
    let value;
    if (e && e.target) {
      ({ value } = e.target);
    } else {
      value = e;
    }
    setCurrentType(value);

    setList([]);
    // getMarketplaceType(value);
  };
  const marketplaceTypeMbile = () => {
    return (
      <div className="marketplace-type-box-mobile">
        <Select
          value={currentType}
          onChange={onChange}
          placeholder="全部"
          className="select-style"
        >
          {categories?.map((item, index) => (
            <Option
              key={index}
              value={item.identifier ? item.identifier : ""}
              className="select-option"
            >
              <span className="label">{item.nameI18n[i18n.language]}</span>
              <span className="count">{item.count}</span>
            </Option>
          ))}
        </Select>
      </div>
    );
  };
  const marketplaceType = () => {
    return (
      <div className="marketplace-type-box">
        {typeLoading && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "40px",
            }}
          >
            <ReactLoading
              type="spinningBubbles"
              color="#396aff"
              height={30}
              width={30}
            />
          </div>
        )}
        {!typeLoading && (
          <>
            <div
              className={classNames({
                "marketplace-type": true,
                fixed: fixedSider,
              })}
            >
              <Input
                placeholder={t("marketplace.other.input-tip")}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
                onPressEnter={searchApp}
                suffix={
                  <span onClick={searchApp}>
                    <i
                      className="icon authing-icon authing-search-line"
                      style={{ color: "#ddd" }}
                    ></i>
                  </span>
                }
                className="marketplace-search"
              />
              {categories?.map((item) => {
                const cls = classNames({
                  "type-item": true,
                  checked:
                    currentType === (item.identifier ? item.identifier : ""),
                });
                return (
                  <div
                    className={cls}
                    onClick={() => {
                      setList([]);
                      // getMarketplaceType(item.identifier ? item.identifier : "");
                      setCurrentType(item.identifier ? item.identifier : "");
                      setCurrentTotal(item.count);
                      setSearchLock(false);
                      isWindow && window.scrollTo(0, 500);
                    }}
                  >
                    <span className="label">
                      {item.nameI18n[i18n.language]}
                    </span>
                    <span className="count">{item.count}</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {marketplaceType()}
      {marketplaceTypeMbile()}
    </>
  );
};
